import API from '../api';

export default class FreecodeCreatorService {
  constructor() {
    this.API = new API();
  }

  loadImplementationVersions = (testId) => this.API.get(`/freecode/edit/${testId}/implementation-versions`);

  exportFreecode = (testId, testImplId) => {
    const query = !testImplId ? '' : `?testImplId=${testImplId}`;
    return this.API.get(`/freecode/${testId}/export${query}`);
  };

  importFreecode = (testId, testImplId, body) => {
    const query = !testImplId ? '' : `?testImplId=${testImplId}`;
    return this.API.put(`/freecode/${testId}/import${query}`, body);
  };
}
